module.exports = __webpack_public_path__ + "static/media/taImg4.5e458e0f.png";